import type { Document } from "@contentful/rich-text-types";
import { BLOCKS } from "@contentful/rich-text-types";

type UseReadingTimeFromRichTextOptions = {
    wordsPerMinute: number;
};

export const useReadingTimeFromRichText = (
    data: Document | null | undefined,
    options: UseReadingTimeFromRichTextOptions
) => {
    if (!data) {
        return 0;
    }

    const words = data.content.reduce((acc, node) => {
        if (
            node.nodeType === BLOCKS.PARAGRAPH ||
            node.nodeType === BLOCKS.HEADING_1 ||
            node.nodeType === BLOCKS.HEADING_2 ||
            node.nodeType === BLOCKS.HEADING_3 ||
            node.nodeType === BLOCKS.HEADING_4 ||
            node.nodeType === BLOCKS.HEADING_5 ||
            node.nodeType === BLOCKS.HEADING_6 ||
            node.nodeType === BLOCKS.OL_LIST ||
            node.nodeType === BLOCKS.UL_LIST ||
            node.nodeType === BLOCKS.QUOTE ||
            node.nodeType === BLOCKS.TABLE
        ) {
            acc += node.content.reduce((acc, node) => {
                if (node.nodeType === "text") {
                    acc += node.value.split(" ").length;
                }
                return acc;
            }, 0);
        }
        return acc;
    }, 0);

    const wordPerMinute = options.wordsPerMinute || 200;

    return Math.ceil(words / wordPerMinute);
};
